export const borderStyles = Object.freeze({
  solid: 'solid',
  dashed: 'dashed',
} as const);

export const borderWidths = Object.freeze({
  normal: '1px',
  heavy: '2px',
});
